import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { URL } from "./utils";

// Base query with 15s timeout. Auth is bearer-token-only; no cookies/refresh.
const baseQuery = fetchBaseQuery({
  baseUrl: `${URL.url}`,
  fetchFn: async (input, init) => {
    const controller = new AbortController();
    const timeoutMs = 15000;
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    try {
      return await fetch(input, {
        ...init,
        signal: controller.signal,
      });
    } finally {
      clearTimeout(timeoutId);
    }
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  // 401 — Token expired veya geçersiz → session-expired event
  if (result?.error?.status === 401) {
    window.dispatchEvent(
      new CustomEvent("session-expired", {
        detail: { reason: "token_expired" },
      })
    );
  }

  // 403 — Hesap doğrulanmamış veya başka cihazdan giriş
  if (result?.error?.status === 403) {
    const errorData = result?.error?.data;
    const message =
      typeof errorData === "object" ? errorData?.message : errorData;

    if (
      message?.includes("başka bir cihaz") ||
      message?.includes("another device")
    ) {
      window.dispatchEvent(
        new CustomEvent("session-expired", {
          detail: { reason: "another_device" },
        })
      );
    }

    if (
      message?.includes("doğrulanmamış") ||
      message?.includes("not_verified")
    ) {
      window.dispatchEvent(
        new CustomEvent("session-expired", {
          detail: { reason: "account_not_verified" },
        })
      );
    }
  }

  // 502, 503, 504, FETCH_ERROR — Server unreachable
  if (
    [502, 503, 504].includes(result?.error?.status) ||
    result?.error?.status === "FETCH_ERROR"
  ) {
    window.dispatchEvent(new CustomEvent("server-unreachable"));
  }

  // Başarılı yanıt — server erişilebilir
  if (!result?.error) {
    window.dispatchEvent(new CustomEvent("api-success"));
  }

  return result;
};

export { baseQuery, baseQueryWithReauth };
